const formatCurrency = (source: string | number | undefined) => {
    if (source === null || source === undefined || isNaN(Number(source))) return null;
    const formater = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    return formater.format(Number(source));
};


export {
    formatCurrency
};